import { Component, ReflectiveInjector } from '@angular/core';
import { NotificationService } from './shared/utils/notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  public title = 'app works!';

  template = '<div class=\'load-senac\'><img src=\'../assets/img/load.gif\'/></div> '

  public constructor(public notificationService: NotificationService) {

  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts